import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppStore } from "../zustand/useAppStore";
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';
import { useAuthStore } from "../zustand/useAuthStore";




 const Header = ({headerData}) => {

const navigate = useNavigate()
 
const location = useLocation(); 

const isSelected = (route) => location.pathname.startsWith(`${route}`);



  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeBranch, setActiveBranch] = useState('الفرع الرئيسي - صنعاء');
  
  // 🌟 NEW: Theme State
  const { themeMode , toggleTheme } = useAppStore();

  const { logout  } = useAuthStore();

  const isDarkMode = themeMode === 'dark';

  



  

const hasData =headerData && headerData.length > 0;

return (
    <>
   

  <div dir="rtl" className="flex w-full h-screen bg-bg-primary  text-text-primary overflow-hidden transition-colors duration-300">
 
    
      {/* --- OVERLAY FOR MOBILE SIDEBAR --- */}
      <AnimatePresence>
        {isSidebarOpen && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setIsSidebarOpen(false)}
            className="fixed inset-0 bg-black/50 z-40 lg:hidden backdrop-blur-sm"
          />
        )}
      </AnimatePresence>

      {/* --- SIDEBAR --- */}
      <aside 
        className={`fixed lg:static inset-y-0 right-0 z-50 w-72 bg-bg-secondary border-l border-border flex flex-col transition-transform duration-300 ease-in-out ${
          isSidebarOpen ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'
        }`}
      >
        <div className="p-2 flex items-center justify-between">
          <div onClick={()=>{
            navigate('')
            setIsSidebarOpen(false)
            }} className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-slate-200 flex items-center justify-center ">
              <img className="w-[96%] aspect-square " src="https://admin.ustathi.app/logo512.png" alt=" فيوتشر سويفت" />
            </div>
            <h1 className="text-xl md:text-2xl font-black text-text-primary">
              فيوتشر سويفت
            </h1>
          </div>
          <button onClick={() => setIsSidebarOpen(false)} className="lg:hidden text-text-secondary hover:text-status-danger transition">
            <Icon icon="solar:close-circle-bold" className="text-2xl" />
          </button>
        </div>
          
            <div className=" flex w-[95%] mx-auto sm:hidden items-center gap-2 bg-bg-tertiary  px-4 rounded-xl border border-border cursor-pointer hover:opacity-80 transition">
              <Icon icon="solar:map-point-bold-duotone" className="text-brand-primary text-xl" />
              <select 
                className="bg-transparent max-w-[100%] grow border-none py-2 text-sm font-bold text-text-primary focus:outline-none cursor-pointer"
                value={activeBranch}
                onChange={(e) => setActiveBranch(e.target.value)}
              >
                <option className="bg-bg-tertiary">الفرع الرئيسي - صنعاء </option>
                <option className="bg-bg-tertiary">فرع التوزيع - عدن</option>
                <option className="bg-bg-tertiary">المستودع المركزي</option>
              </select>
            </div>

        <nav className="flex-1 overflow-y-auto px-4 py-4 space-y-2">
           <button 
             
               onClick={()=>{
                navigate('')
               setIsSidebarOpen(false);
                }} 
              className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl font-bold transition-all hover:-translate-x-1 active:scale-95   ${
                location.pathname === `/` || location.pathname === `/Dashboard`
                  ? 'bg-brand-light text-brand-primary  shadow-sm ' 
                  : 'bg-bg-tertiary text-text-primary hover:bg-bg-primary '
              }`}
            >
              <Icon icon={`solar:home-angle-bold-duotone`} className={`text-2xl ${ location.pathname === `/` || location.pathname === `/Dashboard` ? 'text-brand-primary' : 'text-text-primary'}`} />
              الرئيسية
            </button>
          {hasData &&  headerData.filter(v=>Number(v.hidden) < 1 ).map((item,index) => (
            <button 
              key={item.id}
               onClick={()=>{
                navigate(item.route)
                setIsSidebarOpen(false);
                }} 
              className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl font-bold transition-all  hover:-translate-x-1 active:scale-95  ${
                isSelected(item.route) 
                  ? 'bg-brand-light text-brand-primary shadow-sm ' 
                  : 'bg-bg-tertiary text-text-primary hover:bg-bg-primary '
              }`}
            >
              <Icon icon={item.icon} className={`text-2xl ${ isSelected(item.route) ? 'text-brand-primary' : 'text-text-primary'}`} />
              {item.title}
            </button>
          ))}


        <button 
             
               onClick={()=>{
                navigate("Settings")
               setIsSidebarOpen(false);
                }} 
             className={`group w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl font-bold transition-all hover:-translate-x-1 active:scale-95 ${
                isSelected("/Settings") 
                  ? 'bg-brand-light text-brand-primary shadow-sm ' 
                  : 'bg-bg-tertiary text-text-primary hover:bg-bg-primary   '
              }`}
            >
              <Icon icon={"solar:settings-bold-duotone"} className={`text-2xl  ${ isSelected("/Settings") ? 'text-brand-primary' : 'text-text-primary'} `} />
            الإعدادات
            </button>
          <button 
             
               onClick={()=>{
            
                logout()
               
                }} 
              className={`w-full self-end flex items-center gap-4 px-4 py-3.5 rounded-2xl font-bold transition-all hover:-translate-x-1 active:scale-95 
                
                 
                 bg-bg-tertiary text-red-500  hover:bg-bg-primary 
              `}
            >
              <Icon icon={`solar:logout-2-bold-duotone`} className={`text-2xl text-red-500 `} />
              تسجيل خروج
            </button>
        </nav>



        {/* Status Box */}
        <div className="p-4 m-4 bg-bg-tertiary rounded-2xl border border-border shadow-sm">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-2 h-2 rounded-full bg-status-success animate-pulse" />
            <span className="text-sm font-bold text-text-primary">النظام متصل</span>
          </div>
          <p className="text-xs text-text-secondary leading-relaxed">المزامنة تعمل بشكل مثالي.</p>
         {/* <p className="text-xs text-text-secondary leading-relaxed">المزامنة مع Redis تعمل بشكل مثالي.</p>*/}
        </div>
      </aside>

      {/* --- MAIN CONTENT AREA --- */}
      <main className="flex-1 flex flex-col h-screen overflow-hidden">
        
        {/* HEADER */}
        <header className="h-16 sm:h-20 bg-bg-secondary/90 backdrop-blur-md border-b border-border flex items-center justify-between px-4 lg:px-8 z-10 transition-colors duration-300">
          <div className="flex items-center gap-3 sm:gap-4">
            <button onClick={() => setIsSidebarOpen(true)} className="lg:hidden p-2 bg-bg-tertiary rounded-xl text-text-secondary">
              <Icon icon="solar:hamburger-menu-linear" className="text-xl sm:text-2xl" />
            </button>
            
            <div className="hidden max-w-[200px] sm:flex items-center gap-2 bg-bg-tertiary  px-4 rounded-xl border border-border cursor-pointer hover:opacity-80 transition">
              <Icon icon="solar:map-point-bold-duotone" className="text-brand-primary text-xl" />
              <select 
                className="bg-transparent max-w-[100%]  border-none py-2 text-sm font-bold text-text-primary focus:outline-none cursor-pointer"
                value={activeBranch}
                onChange={(e) => setActiveBranch(e.target.value)}
              >
                <option className="bg-bg-tertiary ">الفرع الرئيسي - صنعاء</option>
                <option className="bg-bg-tertiary">فرع التوزيع - عدن</option>
                <option className="bg-bg-tertiary">المستودع المركزي</option>
              </select>
            </div>
          </div>

          <div className="flex items-center gap-2 sm:gap-4">
            
            {/* 🌟 NEW: Animated Theme Toggle Button */}
            <button 
              onClick={() => toggleTheme()} 
              className="p-2 sm:p-2.5 bg-bg-tertiary rounded-xl text-text-secondary hover:text-brand-primary border border-border transition-colors flex items-center justify-center"
              title="تغيير المظهر"
            >
              <motion.div
                initial={false}
                animate={{ rotate: isDarkMode ? 0 : 180, }}
                transition={{ duration: 0.4, type: "spring", stiffness: 200 }}
              >
                <Icon 
                  icon={isDarkMode ? "solar:moon-stars-bold-duotone" : "solar:sun-2-bold-duotone"} 
                  className="text-lg sm:text-xl" 
                />
              </motion.div>
            </button>

            <button className="relative p-2 text-text-secondary hover:text-brand-primary transition">
              <Icon icon="solar:bell-bing-bold-duotone" className="text-xl sm:text-2xl" />
              <span className="absolute top-1.5 right-1.5 sm:top-1 sm:right-2 w-2 h-2 sm:w-2.5 sm:h-2.5 bg-status-danger rounded-full border-2 border-bg-secondary" />
            </button>
            
            <div className="h-6 sm:h-8 w-px bg-border mx-1 sm:mx-2" />
            
            <div onClick={()=>{
            navigate('')
            setIsSidebarOpen(false)
            }} className="flex items-center gap-2 sm:gap-3 cursor-pointer">
              <div className="text-left hidden sm:block">
                <p className="text-sm font-bold text-text-primary">مدير النظام</p>
                <p className="text-xs text-text-secondary">Super Admin</p>
              </div>
              <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl shadow-sm bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white font-bold text-sm">
                A
              </div>
            </div>
          </div>
        </header>

        

 {/* DASHBOARD CONTENT */}
<div className="w-full flex-1 overflow-y-auto bg-primary ">
    {/* Scrollable Sub-Navigation Bar */}
      <div className="w-full border-b-2   border-border  lg:hidden ">
        <nav 
          dir="rtl" 
          // Hides the scrollbar while keeping it scrollable
          className="flex items-center gap-2  px-2 py-1 overflow-x-auto whitespace-nowrap  max-w-[1400px]  w-full"
        >
         {hasData &&  headerData.filter(v=>Number(v.hidden) < 1 ).map((item,index) => (
            <button 
              key={item.id}
               onClick={()=>{
                navigate(item.route)
                setIsSidebarOpen(false);
                }} 
              className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl font-bold  ${
                isSelected(item.route) 
                  ? 'bg-brand-light text-brand-primary shadow-sm' 
                  : 'bg-bg-tertiary text-text-primary hover:bg-bg-secondary '
              }`}
            >
              <Icon icon={item.icon} className={`text-2xl ${ isSelected(item.route) ? 'text-brand-primary' : 'text-text-primary'}`} />
              {item.title}
            </button>
          ))}
        </nav>
      </div>


   
<Outlet />
</div>
</main>
</div> 
</>
);
};


export default Header;